import React from 'react';
import { Form } from "react-bootstrap";

function PainAssessment({chat}) {
  return (
    <div className="covid-19-risk-checker">
      <h6 className="p-2">Pain Profile Assessment</h6>
      <div className="pb-1">
        <div>
          <div className="d-flex questionnaire-row">
            <label className="col-4 field-label">Result</label>
            <div className="col-8">
              <Form.Control type="text" value={`${chat?.pain_assessment?.level?.replace(/_/g, ' ').replace(/^\w/, c => c.toUpperCase())} (${chat?.pain_assessment?.result?.status})`} className="symptoms-field disabled-field" disabled/>
            </div>
          </div>
          <div className="d-flex questionnaire-row">
              <label className="col-4 field-label">Possible Condition</label>
              <div className="col-8">
                <Form.Control type="text" value={chat?.pain_assessment?.stress_type || '-'}  className="symptoms-field disabled-field" disabled/>
              </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PainAssessment;